import React, { useState } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { Layout, Menu, theme, Typography } from 'antd';
import {
    BorderlessTableOutlined,
    MessageOutlined,
    LinkOutlined
} from '@ant-design/icons';

const { Content, Footer, Sider } = Layout;
const { Title } = Typography;

// Define menu items as a constant array
const menuItems = [
    {
        href: '/board/export-posts',
        icon: MessageOutlined,
        label: 'Посты',
    },
    {
        href: '/board/export-channels',
        icon: BorderlessTableOutlined,
        label: 'Каналы',
    },
    {
        href: '/board/query',
        icon: LinkOutlined,
        label: 'Query',
    },
];

// Create a function to generate menu items
const generateMenuItems = (items: any) =>
    items.map((item: any) => ({
        key: item.href,
        icon: React.createElement(item.icon),
        label: <Link to={item.href}>{item.label}</Link>,
    }));

const Board: React.FC = () => {
    const { token } = theme.useToken();
    const location = useLocation();
    const [sidebarCollapsed, setSidebarCollapsed] = useState(true);

    return (
        <Layout hasSider style={{ height: '100vh' }}>
            <Sider
                // collapsible
                collapsed={sidebarCollapsed}
                onCollapse={setSidebarCollapsed}
                style={{
                    overflow: 'auto',
                    height: '100vh',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    position: 'fixed',
                    transition: 'none',
                }}
            >
                <a
                    href="https://cloudbuying.ru"
                    target="_blank"
                    rel="noreferrer"
                    className="demo-logo-vertical"
                    style={{
                        padding: '20px 0',
                        margin: 8,
                        textAlign: 'center',
                        background: token.colorBgContainer,
                        borderRadius: token.borderRadiusLG,
                        display: 'block',
                        cursor: 'pointer',
                    }}
                >
                    <Title
                        level={sidebarCollapsed ? 5 : 4}
                        style={{
                            margin: 0,
                            userSelect: 'none',
                        }}
                    >
                        C<span style={{ color: '#ba80e6' }}>B</span>
                    </Title>
                </a>
                <Menu
                    theme="dark"
                    mode="inline"
                    defaultSelectedKeys={[location.pathname]}
                    items={generateMenuItems(menuItems)}
                />
            </Sider>
            <Layout>
                <Content
                    style={{
                        margin: '12px 12px 6px 90px',
                        overflow: 'initial',
                        overflowX: 'auto',
                        marginLeft: sidebarCollapsed ? 90 : 210,
                        // transition: 'margin 0.2s',
                        position: 'relative',
                    }}
                >
                    <div
                        style={{
                            padding: 24,
                            textAlign: 'center',
                            background: token.colorBgContainer,
                            borderRadius: token.borderRadiusLG,
                            height: '100%',
                            position: 'relative',
                        }}
                    >
                        <Outlet />
                    </div>
                </Content>
                <Footer style={{ textAlign: 'center', padding: '4px 50px 6px 50px' }}>
                    <div>CloudBuying ©{new Date().getFullYear()} Создано W-RED</div>
                    <div>
                        сборка {
                            (localStorage.getItem('version_current') || `DEV`).replace('from', 'от')
                        }
                    </div>
                </Footer>
            </Layout>
        </Layout>
    );
};

export default Board;